var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import bannerArtes from '../../App/assets/Banner-plataforma-Hub.png';
import bannerArtApprovalTutorial from '../../App/assets/banner-art-approval-tutorial-link.png';
import bannerCeletiExpress from '../../App/assets/banner-celetiexpress-cupom.png';
import '../styles/Home.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useIsMobile } from '../../App/hooks/useIsMobile';
import bannerArtesMobile from '../../App/assets/Banner-plataforma-Hub-mobile.png';
import bannerArtApprovalMobile from '../../App/assets/banner-art-approval-tutorial-mobile.png';
import bannerCeletiExpressMobile from '../../App/assets/banner-celetiexpress-mobile.png';
import bannerBets from '../../App/assets/Banner-plataforma-Hub-bets.png';
import bannerBetsMobile from '../../App/assets/Banner-plataforma-Hub-bets-mobile.png';
function PromotionBanner() {
    var _a = useState(0), currentSlide = _a[0], setCurrentSlide = _a[1];
    var _b = useState(false), isMouseOver = _b[0], setIsMouseOver = _b[1];
    var isMobile = useIsMobile();
    var banners = [
        {
            desktop: bannerCeletiExpress,
            mobile: bannerCeletiExpressMobile,
            link: 'https://plataforma.celetihub.com.br/billings',
        },
        {
            desktop: bannerArtes,
            mobile: bannerArtesMobile,
            link: 'https://supercomm.notion.site/Acervo-para-provedores-24d99a7272848044bff0c4aade98861b',
            alt: 'Baixe as imagens de conteúdos mensais atualizados!',
        },
        {
            desktop: bannerArtApprovalTutorial,
            mobile: bannerArtApprovalMobile,
            link: 'https://supercomm.notion.site/Tutorial-Fluxo-de-aprova-o-de-artes-ISP-1c999a727284819d82ccd55bf39dc320',
            alt: 'Ficou ainda mais fácil aprovar as suas artes! Clique aqui e confira o novo fluxo!',
        },
        {
            desktop: bannerBets,
            mobile: bannerBetsMobile,
            link: 'https://api.celetihub.com.br/storage/docs/comunicado-de-remocao-publicidade-de-bet.pdf',
            alt: 'Confira as novidades da plataforma Bets!',
        },
    ];
    useEffect(function () {
        if (banners.length > 1 && !isMouseOver) {
            var interval_1 = setInterval(function () {
                setCurrentSlide(function (prev) { return (prev + 1) % banners.length; });
            }, 4000);
            return function () { return clearInterval(interval_1); };
        }
    }, [banners.length, isMouseOver]);
    function nextSlide() {
        setCurrentSlide(function (prev) { return (prev + 1) % banners.length; });
    }
    function prevSlide() {
        setCurrentSlide(function (prev) { return (prev - 1 + banners.length) % banners.length; });
    }
    if (banners.length === 1) {
        return (_jsx("div", __assign({ className: "container-promotion-banner" }, { children: _jsx(Link, __assign({ to: banners[0].link, target: "_blank" }, { children: _jsx("div", __assign({ className: "promotion-banner" }, { children: _jsx("img", { src: isMobile
                            ? banners[0].mobile
                            : banners[0].desktop, alt: banners[0].alt }) })) })) })));
    }
    return (_jsx("div", __assign({ className: "container-promotion-banner" }, { children: _jsx("div", __assign({ className: "promotion-carousel", onMouseEnter: function () { return setIsMouseOver(true); }, onMouseLeave: function () { return setIsMouseOver(false); } }, { children: _jsxs("div", __assign({ className: "promotion-carousel-container" }, { children: [_jsx("button", __assign({ className: "promotion-carousel-btn prev", onClick: prevSlide, "aria-label": "Banner anterior", style: { position: 'absolute', top: '42%' } }, { children: _jsx(ArrowBackIosIcon, {}) })), _jsx("div", __assign({ className: "promotion-carousel-track", style: {
                            transform: "translateX(-".concat(currentSlide * 100, "%)"),
                        } }, { children: banners.map(function (banner, index) { return (_jsx("div", __assign({ className: "promotion-carousel-slide" }, { children: _jsx(Link, __assign({ to: banner.link, target: "_blank" }, { children: _jsx("div", __assign({ className: "promotion-banner" }, { children: _jsx("img", { src: isMobile
                                            ? banner.mobile
                                            : banner.desktop, alt: banner.alt }) })) })) }), index)); }) })), _jsx("button", __assign({ className: "promotion-carousel-btn next", onClick: nextSlide, "aria-label": "Pr\u00F3ximo banner", style: { position: 'absolute', top: '42%', right: '0' } }, { children: _jsx(ArrowForwardIosIcon, {}) }))] })) })) })));
}
export default PromotionBanner;
